import { format, isValid, parseISO } from 'date-fns'

function normalizeNote(text) {
  if (text == null) return ''
  return String(text).trim()
}

function parseTimelineDate(value) {
  if (!value) return null
  const d = typeof value === 'string' ? parseISO(value.split('T')[0]) : new Date(value)
  return isValid(d) ? d : null
}

function formatTimelineDateRange(start, end) {
  const s = parseTimelineDate(start)
  const e = parseTimelineDate(end)
  if (!s && !e) return ''
  const fmt = (d) => format(d, 'MMM d, yyyy')
  if (s && e && +s !== +e) return `${fmt(s)} – ${fmt(e)}`
  if (s) return fmt(s)
  if (e) return fmt(e)
  return ''
}

/**
 * Builds a stable, sorted list of timeline-related notes for the current campaign scenario.
 * Scenario notes come from actions; project timeline notes come from campaign_scenarios_project_assets.
 */
export function collectTimelineNotes(campaignScenario) {
  if (!campaignScenario) return []

  const rows = []

  for (const action of campaignScenario.actions || []) {
    const body = normalizeNote(action.notes)
    if (!body) continue
    const user = action.auth_username || action.username
    const title = [user, action.name].filter(Boolean).join(' — ') || action.name || `Action ${action.id}`
    rows.push({
      key: `action-${action.id}`,
      kind: 'scenario',
      label: 'Scenario asset',
      title,
      sourceAsset: action,
      dateSort: parseTimelineDate(action.start_date),
      dateLabel: formatTimelineDateRange(action.start_date, action.end_date),
      body
    })
  }

  for (const cspa of campaignScenario.campaign_scenarios_project_assets || []) {
    const body = normalizeNote(cspa.notes)
    if (!body) continue
    rows.push({
      key: `cspa-${cspa.id}`,
      kind: 'project',
      label: 'Project asset',
      title: cspa.name || `Project asset ${cspa.project_asset_id}`,
      sourceAsset: cspa,
      dateSort: parseTimelineDate(cspa.start_date),
      dateLabel: formatTimelineDateRange(cspa.start_date, cspa.end_date),
      body
    })
  }

  rows.sort((a, b) => {
    const at = a.dateSort?.getTime() ?? Number.MAX_SAFE_INTEGER
    const bt = b.dateSort?.getTime() ?? Number.MAX_SAFE_INTEGER
    if (at !== bt) return at - bt
    return String(a.key).localeCompare(String(b.key))
  })

  return rows
}
